import { createContext, useContext, useEffect, useState } from "react";

const WishlistContext = createContext(null);
const KEY = "nc_wishlist";

const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch {} };

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState(read);
  useEffect(() => write(items), [items]);

  const toggle = (product) => {
    setItems((prev) => {
      const exists = prev.find((p) => p.id === product.id);
      if (exists) return prev.filter((p) => p.id !== product.id);
      return [...prev, { id: product.id, name: product.name, price: product.price, slug: product.slug, image: product.images?.[0] || "" }];
    });
  };
  const has = (id) => items.some((p) => p.id === id);
  const remove = (id) => setItems((prev) => prev.filter((p) => p.id !== id));

  return (
    <WishlistContext.Provider value={{ items, toggle, has, remove, count: items.length }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
